import { render, staticRenderFns } from "./ReturnsBoardSelector.vue?vue&type=template&id=7d76edee&"
import script from "./ReturnsBoardSelector.vue?vue&type=script&lang=js&"
export * from "./ReturnsBoardSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports